export default __webpack_public_path__ + "static/media/alexander.7ee07afd.webp";